var _excluded = ["children", "clickable", "delayIn", "delayOut", "id", "place", "size"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import ReactTooltip from 'react-tooltip';
import styled from 'styled-components';
// styles must be scoped to a className for specificity
var ReactTooltipClassName = '__react_component_tooltip';
var TooltipContainer = styled(ReactTooltip).withConfig({
  componentId: "CL__sc-6k164u-0"
})(["&.", "{--color-background-tooltip:var(--black);--color-text-tooltip:var(--white);}[data-theme='dark'] &.", "{--color-background-tooltip:var(--white);--color-text-tooltip:var(--black);}&.", "{background:var(--color-background-tooltip);color:var(--color-text-tooltip);", " ", " ", " font:var(--tooltip-font);font-weight:600;padding:var(--tooltip-padding);&.place-top{margin-top:var(--tooltip-margin);}&.place-right{margin-right:var(--tooltip-margin);}&.place-bottom{margin-bottom:var(--tooltip-margin);}&.place-left{margin-left:var(--tooltip-margin);}border:none;border-radius:var(--border-radius-small);box-shadow:var(--box-shadow-small);&:after{display:none;}}"], ReactTooltipClassName, ReactTooltipClassName, ReactTooltipClassName, _ref => {
  var {
    size
  } = _ref;
  return size === 'small' && "\n        --tooltip-font: var(--body-text-x-small);\n        --tooltip-padding: 3px var(--spacing-2);\n        --tooltip-margin: -4px;\n        ";
}, _ref2 => {
  var {
    size
  } = _ref2;
  return size === 'medium' && "\n        --tooltip-font: var(--body-text-small);\n        --tooltip-padding: var(--spacing-1) var(--spacing-3);\n        --tooltip-margin: -4px;";
}, _ref3 => {
  var {
    size
  } = _ref3;
  return size === 'large' && "\n        --tooltip-font: var(--body-text-medium);\n        --tooltip-padding: var(--spacing-2) var(--spacing-4);\n        --tooltip-margin: -10px;\n      ";
});

// whenever a child cta focuses, update refMenuIsFocused
// we need this because the keyboard can still be used while the menu is open
// but not focused (e.g. you open the menu then shift+tab backward)
var getDelayValue = delaySpeed => {
  return delaySpeed === 'fast' ? 500 : 750;
};
var Tooltip = _ref4 => {
  var {
      children,
      clickable = false,
      delayIn,
      delayOut,
      id,
      place = 'top',
      size = 'medium'
    } = _ref4,
    props = _objectWithoutProperties(_ref4, _excluded);
  return /*#__PURE__*/React.createElement(TooltipContainer, _extends({
    clickable: clickable,
    delayHide: delayOut ? getDelayValue(delayOut) : 0,
    delayShow: delayIn ? getDelayValue(delayIn) : 0,
    effect: "solid",
    id: id,
    offset: {
      top: 2,
      right: 2,
      bottom: 2,
      left: 2
    },
    place: place,
    role: "tooltip",
    size: size
  }, props), children);
};
export default Tooltip;